import { apiFetch } from '@ami/react/core';
import { TineDiagram } from '../tine-diagrams/tineDiagram';

const _baseEndPoint = 'tine-diagrams';

export default {
  get: async (item) => {
    const entity = await apiFetch(`${_baseEndPoint}`, 'POST', item);
    return new TineDiagram(entity);
  },
};
